import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from "react-router-dom";
import "./index.css";

import { ThemeProvider } from './shared/contexts/ThemeContext';
import { EntryProvider } from './shared/contexts/EntryContext';

// Rotas separadas por ambiente
import InstitucionalRoutes from "./pages/institucional/routes";
import HomecareRoutes from "./pages/homecare/routes";
import RespiratorioRoutes from "./pages/respiratorio/routes";
import AuditivoRoutes from "./pages/auditivo/routes";

const site = process.env.REACT_APP_SITE;

function AppSelector() {
  switch (site) {
    case "institucional":
      return <InstitucionalRoutes />;

    case "homecare":
      return <HomecareRoutes />;

    case "respiratorio":
      return <RespiratorioRoutes />;

    case "auditivo":
      return <AuditivoRoutes />;
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Router>
      <ThemeProvider>
        <EntryProvider>
          <AppSelector />
        </EntryProvider>
      </ThemeProvider>
    </Router>
  </React.StrictMode>
);
